export default {
    data() {
        return {
            ums: new UMS(),
            apiURL: "",
            umsConfigSet: false,
            configOptions: ""
        }
    },
    beforeMount() {

        this.umsSetConfig();
    },
    methods: {
        umsGetConfig() {

            return this.umsConfigSet;
        },
        umsSetConfig() { //by default this method will call

            let umsIsReady = this.umsGetConfig();

            this.isLoading = true;
            if (!umsIsReady) { //if ums object is already set then it wil skip the below block

                let ums = this.ums;
                let routeParams;
                let showNoParamsMessage = false;

                if (this.$route.query.q) {
                    routeParams = this.$route.query.q;
                }

                if (this.$route.params.name) {

                    routeParams = this.$route.params.name;
                }

                this.paramDecode(routeParams); //it will decode the base64 url params and set the config file
                this.apiURL = this.ums.apiHost;

                ums.init(this.configOptions) //this will initialize the JS UMS library and set ready
                    .then((user) => {

                        this.umsConfigSet = ums.isReady;
                        this.isLoading = false;
                    })
            }

        },
        setEnvironment(){

            const environment = {
                DEV: 0,
                QA: 1,
                STAGING: 2,
                PROD: 3
            };

            try{

                let env = this.configOptions['environment'].toUpperCase();
                this.configOptions['environment'] = environment[env];
            }
            catch(error){
                console.error("Invalid environment configuration");
            }
        },
        paramDecode(routeParams) {

            if (routeParams) { //if routeParams exist in the url then we will decode the url

                try {
                    const decodeObject = window.atob(routeParams);
                    const decodeParams = JSON.parse(decodeObject);

                    this.configOptions = {
                        environment: decodeParams.env,
                        apiVersion: 'v2',
                        isLoginPage: true,
                        bg: decodeParams.bg,
                        config: decodeParams.config,
                        url: decodeParams.url,
                    }
                    this.setEnvironment(); //setting environment eg dev, staging,prod

                } catch (error) {
                    this.invalidUrl = true;
                    return;
                }

            } else { //otherwise we will set no params in the url

                let config;
                this.showNoParamsMessage = true;
                const hostName = window.location.hostname;

                this.configOptions = {
                    apiVersion: 'v2',
                    isLoginPage: true,
                    appInfo: {
                        name: 'console'
                    }
                }

                this.setEnvironmentUrl();
            }
        },
        setEnvironmentUrl(){

            const environment = {
                DEV: 0,
                QA: 1,
                STAGING: 2,
                PROD: 3
            };

            let hostname = window.location.host.split(/[./-:-]/g);

            if(hostname[0] ==='localhost' || hostname[0] === 'dev' || hostname[0] === 'qa' || hostname[0] === 'staging'){

                this.configOptions.environment = environment['DEV'];
                this.configOptions.url = 'https://dev-console.delhivery.com';
            }
            else{

                this.configOptions.environment = environment['PROD'];
                this.configOptions.url = 'https://console.delhivery.com';
            }

        },
        googleLoginService() {
            this.isLoading = true;
            this.ums.loginWithGooglePlus()
                .then((response) => {
                    this.isLoading = false;
                    this.loginSuccess(response);

                }, error => {
                    this.isLoading = false;

                    this.loginErrorHandle(error)
                })
        },
        otpLoginService(users) {

            this.isLoading = true;

            return this.ums.loginWithOTP(users)
                .then((response) => {
                    this.isLoading = false;
                    this.loginSuccess(response);
                })
                .catch((e) => {
                    this.loginErrorHandle(error)
                    this.isLoading = false;
                });
        },
        getOtpService(phoneNo) {

            let timer = 10;
            this.timeCounter = timer;
            this.showResendOTP = false;
            this.isLoading = true;

            return this.ums.requestOTP(phoneNo)
                .then(() => {
                    this.phoneNumSuccess = true;
                    this.isLoading = false;

                    let count = setInterval(() => {
                        if (this.timeCounter !== 1) {
                            this.timeCounter = this.timeCounter - 1;
                        } else {

                            this.showResendOTP = true;
                            clearTimeout(count);

                        }
                    }, 1000)

                })
                .catch((error) => {

                    this.errorHandler(error);
                    this.isLoading = false;

                });
        },
        localLoginService(user) {
            this.isLoading = true;
            this.ums.login(user)
                .then((response) => {
                        this.isLoading = false;
                        this.loginSuccess(response);
                    },
                    (error) => {
                        this.loginErrorHandle(error);
                        this.isLoading = false;
                    })
        },
        /**this function will call when user clicks on login with username,
            forgot password  and others link
            @params: loginType can be google,password,forgot or otp when clickin on the url
        **/
        showAltForm(loginType) {

            this.defaultView = loginType;

            if (this.defaultView === 'password') {

                this.showGoogle = false;
                this.showlogin = true;
                this.showOtp = false;
                this.showForgotPassword = true;

            } else if (this.defaultView === 'google') {

                 this.showGoogle = true;
                 this.showlogin = false;
                 this.showOtp = true;
                 this.showForgotPassword = false;

            } else if (this.defaultView === 'forgot') {

                this.showGoogle = false;
                this.showlogin = false;
                this.showOtp = false;
                this.showForgotPassword = true;
            }

        },
        loginSuccess() {
            this.showLoading = true;
            setTimeout(() => {
                window.location.href = this.configOptions['url'];
            }, 1000);
        },
        getOtp($event) {

             $event = $event || this.phoneNo;
            if ($event !== undefined) {
                if (!$event.match(/^\d{10}$/)) {
                    this.errorMessage = {
                        type: 'error',
                        message: 'Invalid Phone no.'
                    };

                } else {
                    this.phoneNo = $event;
                    this.getOtpService($event);
                }

            }
        },
        forgotPasswordService(email) {

            this.isLoading = true;
            const params = {
                user: email,
                redirectURL: this.apiURL
            };
            return this.ums.forgotPassword(params)
                .then((response) => {

                    this.isLoading = false;
                    this.phoneNumberEmailSuccess = true;

                })
                .catch((error) => {

                    this.errorHandler(error);
                    this.isLoading = false;

                });
        },
        loginErrorHandle(apiError) {
            const isErrorDict = apiError && typeof apiError.error === 'object' && Object.keys(apiError.error).length;

            if (isErrorDict && apiError.error.error_code && apiError.error.error_code === 'UMS001') {
                this.userErrorInfo = {
                    expiry : true,
                    username: apiError.error.user
                };

                this.redirectTimer(this.userErrorInfo)
            } else {
                this.errorHandler(apiError)
            }
        },
        errorHandler(error) {
            const errorMessage = {
              type: 'error',
              message: error.message
            };

            this.errorMessage = errorMessage;

            setTimeout(() => {
              this.errorMessage = {
                type: 'hideMe'
              };
            }, 8000);

        },

        redirectTimer(errorInfo) {
            this.redirectTime = 5;
            let count = setInterval(() => {
                if (this.redirectTime !== 1) {
                    this.redirectTime = this.redirectTime - 1;
                } else {
                    clearTimeout(count);
                    this.goToChangePasswordPage(errorInfo);
                }
            }, 1000)

        },

        goToChangePasswordPage (errorInfo) {
          const objParams = {
            'username': errorInfo.username,
            'redirect_url': this.configOptions.url
          }
          let base64Data = window.btoa(JSON.stringify(objParams));
          let env = (this.configOptions.environment === 3) ? '' : 'dev-';
          window.location.href = `http://${env}ums.delhivery.com/#!/update-password/${base64Data}`;
        },


    }
}


// WEBPACK FOOTER //
// ./src/mixins/umsinit.js